module.exports = __webpack_public_path__ + "img/hole.557b6dc6.svg";